import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { t } from '../../../helpers/t';
import Header from '../../Header';
import { PrimaryCTA } from '../../Buttons';

export default function OwnerHeader() {
  const { id, is_locked } = useSelector((state) => state.listing, shallowEqual);
  const env = useSelector((state) => state.env, shallowEqual);
  const userLanguage = (env && env.userLanguage) || (window.LOCALE && window.LOCALE.lang) || 'en';
  const langPrefix = userLanguage === 'en' ? '' : `/${userLanguage}`;
  const manageHref = `${langPrefix}/listings/${id}/manage`;

  return is_locked
    ? (
      <Header colorScheme="warning">
        <div className="flex flex-col items-center justify-center">
          <div className="listing-owner-info">
            <div
              className="font-extralight text-orange-800 text-link [&>a]:underline"
              dangerouslySetInnerHTML={{ __html: t('listings.show.listingOwner.manage.locked', { listingId: id }) }}
            />
          </div>
          <PrimaryCTA
            type="warning"
            href={manageHref}
            onClick={(e) => { e.preventDefault(); window.location.href = manageHref; }}
          >
            {t('listings.show.listingOwner.manage.cta')}
          </PrimaryCTA>
        </div>
      </Header>
    )
    : (
      <Header colorScheme="emerald">
        <div className="flex flex-col items-center justify-center">
          <div className="listing-owner-info font-light font-extralight text-emerald-800 text-link">
            {t('listings.show.listingOwner.manage.text')}
          </div>
          <PrimaryCTA
            type="success"
            href={manageHref}
            onClick={(e) => { e.preventDefault(); window.location.href = manageHref; }}
          >
            {t('listings.show.listingOwner.manage.cta')}
          </PrimaryCTA>
        </div>
      </Header>
    );
}
